import Image from 'next/image';
import AsurionLogo from 'public/images/asurion-logo.svg';
import { StyledHeaderLogoContainer } from './elements';

type Props = {
  logoSrc?: string | JSX.Element;
  altText?: string;
  height?: number;
  width?: number;
};

export const HeaderLogo = ({
  logoSrc,
  altText = '',
  height = 40,
  width = 167.15,
}: Props) => (
  <StyledHeaderLogoContainer>
    <Image
      src={logoSrc ?? AsurionLogo}
      className="h-auto max-w-[89px]"
      alt={altText}
      height={height}
      width={width}
    />
  </StyledHeaderLogoContainer>
);
